import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer.js"
import UniqueValueRenderer from "@arcgis/core/renderers/UniqueValueRenderer.js"
import ColorVariable from "@arcgis/core/renderers/visualVariables/ColorVariable.js"
import { getActivePinia } from "pinia"

export const useKlokRenderer = (attribute: string | undefined) => {
    if (!attribute) return
    if (attribute.split(",").length > 1) {
        return createRenderer(attribute.split(",")[0] as string)
    }
    return createRenderer(attribute)
}

const defaultSymbol = {
    type: "simple-fill",
    color: [255, 255, 255],
    outline: {
        color: [255, 255, 255, 0.8],
        width: 1,
    },
}

function createSymbol(color: number[]) {
    return {
        type: "simple-fill",
        color,
        outline: {
            color: [255, 255, 255, 0.5],
            width: 1,
        },
    }
}

function createRenderer(attribute: string) {
    const pinia = getActivePinia()
    const { settings } = useKlokStore(pinia)
    if (!settings || !settings.symbologie[0]) return
    const item = settings.symbologie[0][attribute]
    if (!item) return
    if (item.type === "unique-value") {
        return new UniqueValueRenderer({
            defaultSymbol: defaultSymbol,
            field: item.field,
            uniqueValueInfos: item.uniqueValueInfos.map(valueInfo => ({
                value: valueInfo.value,
                symbol: createSymbol(valueInfo.symbolColor),
                label: valueInfo.label,
                label_en: valueInfo.label_en,
            })),
        })
    } else {
        return new SimpleRenderer({
            symbol: defaultSymbol,
            label: item.label,
            visualVariables: item.visualVariables.map(variable => {
                return new ColorVariable({
                    field: variable.field,
                    stops: variable.stops.map(stop => ({
                        value: stop.value,
                        color: stop.color,
                        label: stop.label,
                        label_en: stop.label_en,
                    })),
                })
            }),
        })
    }
}
